import { AlertCircle, Check, Info } from "react-feather";
import { Alert, CloseButton } from "reactstrap";
import "./AlertCustom.scss";
import { ReactElement } from "react";
import { useDispatch } from "react-redux";
import { handleCloseAlert } from "@src/redux/reducers/alert";

interface AlertCustomProps {
  visible: boolean;
  children?: ReactElement | string;
  type: "warning" | "success" | "danger" | "info";
  
}

const AlertCustom = ({ visible, children, type }: AlertCustomProps) => {
  const dispatch = useDispatch();

  const onDismiss = () =>  dispatch(handleCloseAlert());
  const mapIcon = {
    warning: <AlertCircle size={15} />,
    info: <Info size={15} />,
    success: <Check size={15} />,
    danger: <AlertCircle size={15} />,
  };

const showAlert = () => {}

  return (
    <div className="alert-custom">
      <Alert color={type} isOpen={visible} toggle={onDismiss}>
        <div className="alert-body">
          {mapIcon[type]} <span className="ms-1">{children}</span>
        </div>
      </Alert>
    </div>
  );
};

export default  AlertCustom;


